import React from "react"
import { Tooltip } from "@chakra-ui/react"
import { useRecoilValue } from "recoil"
import useOnClickWithTouchHandler from "../../../hooks/useOnClickWithTouchHandler"
import { brandingSelector } from "../../../recoil/atoms/room"
import {
  ContainerIcon,
  MicIcon,
  MuteButton,
  MuteMicIcon
} from "../videoPlayer/custom-player.styled"
import { useAvatarMicManager } from "src/conditionals/Avatar"

type AvatarMicControlProps = {
  style?: React.CSSProperties
}

export const AvatarMicControl: React.FC<AvatarMicControlProps> = ({
  style
}) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const { isEnabled, toggleMic, micPermissionState } = useAvatarMicManager()

  const toggleMute = useOnClickWithTouchHandler(event => {
    event.stopPropagation()
    event.preventDefault()
    toggleMic()
  })

  return (
    <Tooltip label={"Avatar microphone"} placement="right">
      <MuteButton {...toggleMute} roomStyles={roomStyles} style={style}>
        <ContainerIcon roomStyles={roomStyles}>
          {micPermissionState === "denied" ? <MicIcon color="grey" /> : isEnabled ? <MicIcon /> : <MuteMicIcon /> }
        </ContainerIcon>
      </MuteButton>
    </Tooltip>
  )
}
